import { AuthService } from 'src/app/services/auth.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/internal/operators/map';

@Injectable({
  providedIn: 'root'
})

export class OrganisationService {
  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) { }

  list(pageNumber: number = 1, searchValue: string = '', type: string = 'all') {
    return this.http.post<any>(`${environment.apiUrl}/admin/organisations/list`, {
        page: pageNumber,
        search_name: searchValue,
        type: `${type}`
      })
      .pipe(map(response => {
        this.authService.setNewToken(response.token);
        this.authService.setUserData(response.user);
        return response;
      }));
  }

  listAll() {
    return this.http.get<any>(`${environment.apiUrl}/admin/organisations/all`)
      .pipe(map(response => {
        this.authService.setNewToken(response.token);
        this.authService.setUserData(response.user);
        return response;
      }));
  }

  create(name: string, type: string, domain: string, freeTrial: string, totalUsers: number) {
    return this.http.post<any>(`${environment.apiUrl}/admin/organisations/create`, {
      name: `${name}`,
      type: `${type}`,
      domain: `${domain}`,
      freeTrial: `${freeTrial}`,
      total_users: `${totalUsers}`
    })
      .pipe(map(response => {
        this.authService.setNewToken(response.token);
        this.authService.setUserData(response.user);
        return response;
      }));
  }

  update(organisation_id: number, name: string = '', domain: string = '', status: string = '', type: string = '', freeTrial: string = '', voucher: string = '', total_users: number = 0) {
    return this.http.post<any>(`${environment.apiUrl}/admin/organisations/update`, {
      organisation_id: organisation_id,
      name: name,
      domain: domain,
      status: status,
      type: `${type}`,
      freeTrial: freeTrial,
      voucher: voucher,
      total_users: total_users
    })
      .pipe(map(response => {
        this.authService.setNewToken(response.token);
        this.authService.setUserData(response.user);
        return response;
      }));
  }

  details(organisation_id: number) {
    return this.http.get<any>(`${environment.apiUrl}/admin/organisations/details/`+organisation_id)
      .pipe(map(response => {
        this.authService.setNewToken(response.token);
        this.authService.setUserData(response.user);
        return response;
      }));
  }

  deleteVoucher(organisation_id: number, code: string) {
    return this.http.post<any>(`${environment.apiUrl}/admin/organisations/delete_voucher`, {
      organisation_id: organisation_id,
      code: code,
    })
      .pipe(map(response => {
        this.authService.setNewToken(response.token);
        this.authService.setUserData(response.user);
        return response;
      }));
  }

  checkVoucherUpdateUser(voucher: string) {
    return this.http.post<any>(`${environment.apiUrl}/check_voucher_update_user`, {
      voucher: voucher,
    })
      .pipe(map(response => {
        this.authService.setNewToken(response.token);
        this.authService.setUserData(response.user);
        return response;
      }));

  }

  allVoucher(organisation_id: string) {
    return this.http.post<any>(`${environment.apiUrl}/admin/organisations/all_vouchers`, {
      organisation_id: organisation_id
    })
      .pipe(map(response => {
        this.authService.setNewToken(response.token);
        this.authService.setUserData(response.user);
        return response;
      }));
  }

}
